module.exports = __webpack_public_path__ + "static/loop-alemana-f3158e2b4625567915be1845999414c4.mp4";